//========================================  //
// Helper Functions							//
// ======================================== //
export function is_defined(variable) {
    return typeof (variable) != 'undefined';
}

export function is_object(variable) {
    if (variable === null) {
        return false;
    }

    return ((typeof variable === 'function') || (typeof variable === 'object') && !Array.isArray(variable));
}

export function is_promise(variable) {
    return is_object(variable) && typeof variable.then == 'function';
}

export function is_array(variable) {
    return Array.isArray(variable);
}

export function is_boolean(variable) {
    return variable === true || variable === false;
}

export function is_numeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
}

export function is_string(value) {
    return typeof (value) == 'string';
}

export function is_float(value) {
    return parse_float(value) != parse_int(value);
}

export function is_function(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export function parse_float(value, perc) {
    if (is_string(value)) value = value.replace(/,/gi, '.');
    value = parseFloat(value);
    if (perc) value = parse_float(value.toFixed(perc));
    return value;
}

export function parse_int(value) {
    return parseInt(value, 10);
}

export function trim_value(value, prec) {
    if (is_float(value) || is_float(prec)) {
        prec = 1.0 / prec;
        return Math.round(value * prec) / prec;
    } else {
        return value;
    }
}

export function is_date_str(value) {
    if (!is_string(value) || value == '') return false;
    if (value.split('-').length == 3) return true;
    if (is_string(value)) return true;
    return false;
}

export function nl2br(text) {
    return text.replace(/\n/gi, '<br>');
}

export function br2nl(text) {
    return text.replace(/<br>/gi, '\n');
}

//======================================== //
// Error Handling                          //
//======================================== //
var jsErrorHandler = [];

// Add error handler function
export function addErrorHandlerFunc(func) {
    jsErrorHandler.push(func);
}

// Call registered error handlers
export function callErrorHandlers(message, file, line, col, error) {
    for (var i = 0; i < jsErrorHandler.length; i++) {
        jsErrorHandler[i](message, file, line, col, error);
    }
}

export function enableErrorHandling(enable) {
    if (enable) {
        window.onerror = function (message, file, line, col, error) {
            callErrorHandlers(message, file, line, col, error);
            return true;	// prevent shouting alert message in older browser with true
        };
    } else {
        window.onerror = 0;
    }
}


//======================================== //
// Browser Functions                       //
//======================================== //
export function getBrowser() {
    var agent = navigator.userAgent;
    if (agent.indexOf('Chrome') > -1) {
        return 'Chrome';
    } else if (agent.indexOf('Safari') > -1) {
        return 'Safari';
    } else if (agent.indexOf('Opera') > -1) {
        return 'Opera';
    } else if (agent.indexOf('Firefox') > -1) {
        return 'Firefox';
    } else if (agent.indexOf('MSIE') > -1) {
        return 'MSIE';
    } else if (agent.indexOf('Trident') > -1) return 'MSIE';
    return '';
}

export function isMSIE(versionAndAbove) {
    var myNav = navigator.userAgent.toLowerCase();
    var ieVer = false;
    if (myNav.indexOf('msie') > -1) {
        ieVer = parseInt(myNav.split('msie')[1]);
    }

    if (myNav.indexOf('trident/7') > -1) {
        ieVer = 11;
    }

    if (ieVer) {
        if (versionAndAbove) {
            return ieVer >= versionAndAbove;
        } else {
            return ieVer;
        }
    }

    return false;
}

export function isSafari() {
    return getBrowser() == 'Safari';
}

export function isOpera() {
    return getBrowser() == 'Opera';
}

//======================================== //
// Misc Functions                          //
//======================================== //
export function ord(c) {
    return c.charCodeAt(0);
}

export function chr(o) {
    return String.fromCharCode(o);
}

export function URLToArray(url) {
    var request = {};
    var pairs = url.substring(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < pairs.length; i++) {
        if (!pairs[i]) {
            continue;
        }
        var pair = pairs[i].split('=');
        request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return request;
}

export function joinObjValuesToString(glue, obj) {
    var str = '';
    for (var name in obj) {
        str += obj[name] + glue;
    }
    return str;
}

export function toCurrency(num) {
    // eslint-disable-next-line no-undef
    return num.toLocaleString(LP.getLanguage(), {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

export function format_date(date) {
    var d = new Date(date);
    // eslint-disable-next-line no-undef
    return d.toLocaleDateString(LP.getLanguage(), {year: 'numeric', month: 'short', day: 'numeric'});
}

export function createRandomId() {
    'use strict';

    var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
}

// For legacy code that expects those helpers to be defined on the window object
window['is_defined'] = is_defined;
window['is_object'] = is_object;
window['is_promise'] = is_promise;
window['is_array'] = is_array;
window['is_boolean'] = is_boolean;
window['is_numeric'] = is_numeric;
window['is_string'] = is_string;
window['is_float'] = is_float;
window['is_function'] = is_function;
window['parse_float'] = parse_float;
window['parse_int'] = parse_int;
window['trim_value'] = trim_value;
window['is_date_str'] = is_date_str;
window['nl2br'] = nl2br;
window['br2nl'] = br2nl;
window['addErrorHandlerFunc'] = addErrorHandlerFunc;
window['callErrorHandlers'] = callErrorHandlers;
window['enableErrorHandling'] = enableErrorHandling;
window['getBrowser'] = getBrowser;
window['isMSIE'] = isMSIE;
window['isSafari'] = isSafari;
window['isOpera'] = isOpera;
window['ord'] = ord;
window['chr'] = chr;
window['URLToArray'] = URLToArray;
window['joinObjValuesToString'] = joinObjValuesToString;
window['toCurrency'] = toCurrency;
window['format_date'] = format_date;
window['createRandomId'] = createRandomId;
